<template>
  <div
    v-if="!isLoading"
    id="conditionItem-1"
  >
    <div class="d-flex">
      <input-widget
        :id="`rule-${ruleIndex}-condition-1-logical-conjunction`"
        :model="model"
        :field="fields.LogicalConjunction"
        :toggle-options="toggleOptions"
      />
    </div>
    <expression-item
      :model="model"
      :fields="fields"
      :table-fields="tableFields"
      :rule-index="ruleIndex"
    />
    <condition-item
      :model="model"
      :fields="fields"
      :table-fields="tableFields"
      :toggle-options="toggleOptions"
      :rule-index="ruleIndex"
    />
  </div>
</template>

<script>
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import NoContent from '../../../../../core/components/NoContent';
import ExpressionItem from './ExpressionItem';
import ConditionItem from './ConditionItem';

export default {
  name: 'MainCondition',
  components: {
    ConditionItem,
    ExpressionItem,
    NoContent,
    InputWidget,
  },
  props: {
    model: Object,
    fields: Object,
    tableFields: Array,
    ruleIndex: Number,
  },
  data: () => ({
    isLoading: false,
    toggleOptions: {
      layout: {
        textUpperCase: true,
      },
      size: {
        fontSize: 0.8,
        height: 2.4,
        width: 6,
      },
      items: {
        delay: .4,
        disabled: false,
        labels: [
          {name: 'and', color: '#19407b', backgroundColor: 'white'},
          {name: 'or', color: '#19407b', backgroundColor: 'white'},
        ],
      },
    },
  }),
};
</script>
